import React from 'react';
import { BookOpenIcon, MessageCircleIcon } from 'lucide-react';
import { GENERAL_ENQUIRY_URL } from '../../utils/whatsapp';
import { trackAddToCart } from '../../utils/metaPixel';
export function Header() {
  return <header className="bg-navy" data-id="element-19" data-mp="1eo75yspq8otk">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3.5 sm:px-8" data-id="element-20" data-mp="1ene5ual9wxke">
        <a href="#inicio" className="shrink-0 font-brand text-xl italic tracking-tight text-ivory sm:text-3xl" aria-label="Jam Fragrances, inicio" data-id="element-21" data-mp="19ob4p18ezbhp">
          Jam Fragrances
          <span className="text-lime" data-id="element-22" data-mp="vqmerezhpe5s">.</span>
        </a>

        <nav aria-label="Navegación principal" className="flex items-center gap-2 sm:gap-5" data-id="element-23" data-mp="vs7bnb9a196t">
          <a href="#perfumes" className="hidden text-xs font-semibold uppercase tracking-wide text-ivory/80 transition-colors duration-200 ease-smooth hover:text-lime sm:block" data-id="element-24" data-mp="qz4giyouproi">
            Catálogo
          </a>
          <a href={GENERAL_ENQUIRY_URL} target="_blank" rel="noreferrer" onClick={() => trackAddToCart({
          contentName: 'Catálogo por WhatsApp (header)'
        })} className="flex items-center gap-2 rounded-full border border-lime/50 px-4 py-2.5 text-xs font-bold uppercase tracking-wide text-lime transition-colors duration-200 ease-smooth hover:bg-lime hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-25" data-mp="6vomptrb2x3a">
            <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-26" data-mp="3p1a3njgf3vwq" />
            Catálogo
          </a>
          <a href={GENERAL_ENQUIRY_URL} target="_blank" rel="noreferrer" onClick={() => trackAddToCart({
          contentName: 'Pedido general (header)'
        })} className="flex items-center gap-2 rounded-full bg-lime px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-navy transition-colors duration-200 ease-smooth hover:bg-lime-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-27" data-mp="3u0ed8b797vnl">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-28" data-mp="3aak4bwpthdo8" />
            <span className="hidden sm:inline" data-id="element-29" data-mp="35ciij410b092">Pedir por WhatsApp</span>
            <span className="sm:hidden" data-id="element-30" data-mp="3jdl65l7ngim3">Pedir</span>
          </a>
        </nav>
      </div>
    </header>;
}